import {
    Box,
    Heading,
    ListItem,
    OrderedList,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    Link,
    UnorderedList
} from "@chakra-ui/react";
import React from "react";



// let SERVER_IP;
// let SERVER_IP_MULTIDOC;
// let SERVER_IP_VIDEO;
// let SERVER_IP_SOCKET;
// if (hostname === "dev.honeybear.ai" || hostname === "localhost") {
//     // SERVER_IP = 'https://100.24.205.128.nip.io';
//     SERVER_IP = 'https://34.226.208.115.nip.io';
//     SERVER_IP_MULTIDOC = 'https://34.226.208.115.nip.io';
//     SERVER_IP_VIDEO = 'https://100.24.205.128.nip.io';
//     SERVER_IP_SOCKET = "34.226.208.115.nip.io";
// } else {
//     SERVER_IP = 'https://34.226.208.115.nip.io';
//     SERVER_IP_MULTIDOC = 'https://34.226.208.115.nip.io';
//     SERVER_IP_VIDEO = 'https://3.89.226.93.nip.io';
//     SERVER_IP_SOCKET = "34.226.208.115.nip.io";
// }
//
// export { SERVER_IP };
// export { SERVER_IP_MULTIDOC };
// export { SERVER_IP_VIDEO };
// export { SERVER_IP_SOCKET };


export const influencerMap = {
    "julia": "Hey fans of Julia Bedell! We think you’ll like us too!",
    "sree": "Hey fans of Sree! We think you’ll like us too!",
    "brandon": "Hey fans of Brandon! We think you’ll like us too!",
    "ellie": "Hey fans of Ellie! We think you’ll like us too!",
    "cecile": "Hey fans of Cecile! We think you’ll like us too!",
    "tingting": "Hey fans of TingTing! We think you’ll like us too!",
    "teo": "Welcome Fordham!!!",
    "alyssa-tabling" : "Welcome Cornell!!!"
}

export const modelMap = {
    "fast": "fastest",
    "medium": "max",
    "thinking": "thinking",
    "web search": "websearch",
}

// Heading sm is 16px
// Heading xs is 14px

// Text md is 16px
// Text sm is 14px
export const markdownComponents = {
    h1: ({ node, ...props }) => <Heading as="h1" fontSize={15.5} textDecoration="underline" my={'0.4rem'} {...props} />,
    h2: ({ node, ...props }) => <Heading as="h2" fontSize={15} my={'0.4rem'} {...props} />,
    h3: ({ node, ...props }) => <Heading as="h3" fontSize={15} my={'0.4rem'} {...props} />,
    h4: ({ node, ...props }) => <Heading as="h4" fontSize={15} my={'0.4rem'} {...props} />,
    h5: ({ node, ...props }) => <Heading as="h5" fontSize={15} my={'0.4rem'} {...props} />,
    h6: ({ node, ...props }) => <Heading as="h6" fontSize={15} my={'0.4rem'} {...props} />,
    em: ({ node, ...props }) => <Text as="em" fontStyle="italic" fontSize={15} {...props} />,
    strong: ({ node, ...props }) => <Text as="strong" fontWeight="bold" fontSize={15} {...props} />,
    ul: ({ node, ...props }) => <UnorderedList my={'0.4rem'} fontSize={15} {...props} />,
    ol: ({ node, ...props }) => <OrderedList my={'0.4rem'} fontSize={15} {...props} />,
    li: ({ node, ...props }) => <ListItem fontSize={15} {...props} />,
    table: ({ node, ...props }) => <Table variant="simple" size="sm" my={"0.75rem"} {...props} />,
    thead: Thead,
    tbody: Tbody,
    tr: Tr,
    th: ({ node, ...props }) => <Th px={"0.75rem"} py={"0.5rem"} fontSize={15} {...props} />,
    td: ({ node, ...props }) => <Td px={"0.75rem"} py={"0.5rem"} fontSize={15} {...props} />,
    p: ({ node, ...props }) => <Text fontSize={15} {...props} />,
    blockquote: ({ node, ...props }) => <Box as="blockquote" borderLeft="4px solid" fontSize={15}
                                             borderColor="gray.200" pl={"0.9rem"} my={"0.5rem"} fontStyle="italic" {...props} />,
    a: ({ node, href, ...props }) => (
        <Link href={href} fontSize={15} color="blue.500" textDecoration="underline" isExternal {...props} />
    ),
}

// Helper function to convert markdown tables to HTML
const convertMarkdownTablesToHtml = (text, elementStyles) => {
    const lines = text.split('\n');
    const result = [];
    let i = 0;
    
    while (i < lines.length) {
        const line = lines[i].trim();
        
        // Check if this line looks like a table row (contains | and has multiple cells)
        if (line.includes('|') && line.split('|').filter(cell => cell.trim()).length >= 2) {
            // Look ahead to see if the next line is a separator (contains --- or similar)
            const nextLine = i + 1 < lines.length ? lines[i + 1].trim() : '';
            const isSeparatorLine = nextLine.includes('|') && nextLine.match(/[\|\-\:\s]+/) && nextLine.includes('-');
            
            const tableLines = [];
            let j = i;
            let hasHeader = false;
            
            if (isSeparatorLine) {
                // Standard markdown table with separator
                tableLines.push(line); // header
                j += 2; // skip separator line
                hasHeader = true;
                
                // Collect data rows
                while (j < lines.length && lines[j].trim().includes('|') && lines[j].trim().split('|').filter(cell => cell.trim()).length >= 2) {
                    tableLines.push(lines[j].trim());
                    j++;
                }
            } else {
                // Pipe-separated table without separator (like in your screenshot)
                // Collect all consecutive lines that look like table rows
                while (j < lines.length) {
                    const currentLine = lines[j].trim();
                    if (currentLine.includes('|') && currentLine.split('|').filter(cell => cell.trim()).length >= 2) {
                        tableLines.push(currentLine);
                        j++;
                    } else {
                        break;
                    }
                }
                // For pipe-separated tables, treat first row as header if we have multiple rows
                hasHeader = tableLines.length > 1;
            }
            
            if (tableLines.length > 0) {
                // Convert to HTML table
                const htmlTable = convertTableLinesToHtml(tableLines, elementStyles, hasHeader);
                result.push(htmlTable);
                i = j;
                continue;
            }
        }
        
        result.push(lines[i]);
        i++;
    }
    
    return result.join('\n');
};

// Helper function to convert table lines to HTML
const convertTableLinesToHtml = (tableLines, elementStyles, hasHeader = true) => {
    if (tableLines.length === 0) return '';
    
    let html = `<table style="${elementStyles.table}">`;
    
    // Parse all rows
    const allRows = tableLines.map(line => 
        line.split('|').map(cell => cell.trim()).filter(cell => cell !== '')
    );
    
    if (hasHeader && allRows.length > 0) {
        // First row is header
        const headerCells = allRows[0];
        const dataRows = allRows.slice(1);
        
        // Add header
        html += '<thead><tr>';
        headerCells.forEach(cell => {
            html += `<th style="${elementStyles.th}">${cell}</th>`;
        });
        html += '</tr></thead>';
        
        // Add body
        if (dataRows.length > 0) {
            html += '<tbody>';
            dataRows.forEach(row => {
                html += '<tr>';
                row.forEach(cell => {
                    html += `<td style="${elementStyles.td}">${cell}</td>`;
                });
                html += '</tr>';
            });
            html += '</tbody>';
        }
    } else {
        // All rows are data rows (no header)
        html += '<tbody>';
        allRows.forEach(row => {
            html += '<tr>';
            row.forEach(cell => {
                html += `<td style="${elementStyles.td}">${cell}</td>`;
            });
            html += '</tr>';
        });
        html += '</tbody>';
    }
    
    html += '</table>';
    return html;
};

// Utility function to convert markdown to HTML for clipboard copying
// This function creates HTML that matches the styling from markdownComponents
export const markdownToHtml = (markdownText) => {
    if (!markdownText) return '';
    
    // Base styles that match our markdownComponents
    const baseStyles = `
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
        line-height: 1.6;
        color: #000000;
    `;
    
    const elementStyles = {
        h1: 'font-size: 15.5px; font-weight: bold; text-decoration: underline; margin: 0.4rem 0;',
        h2: 'font-size: 15px; font-weight: bold; margin: 0.4rem 0;',
        h3: 'font-size: 15px; font-weight: bold; margin: 0.4rem 0;',
        h4: 'font-size: 15px; font-weight: bold; margin: 0.4rem 0;',
        h5: 'font-size: 15px; font-weight: bold; margin: 0.4rem 0;',
        h6: 'font-size: 15px; font-weight: bold; margin: 0.4rem 0;',
        p: 'font-size: 15px; margin: 0.2rem 0;',
        strong: 'font-weight: bold; font-size: 15px;',
        em: 'font-style: italic; font-size: 15px;',
        ul: 'font-size: 15px; margin: 0.4rem 0; padding-left: 1.5rem;',
        ol: 'font-size: 15px; margin: 0.4rem 0; padding-left: 1.5rem;',
        li: 'font-size: 15px; margin: 0.1rem 0;',
        blockquote: 'font-size: 15px; border-left: 4px solid #E2E8F0; padding-left: 0.9rem; margin: 0.5rem 0; font-style: italic;',
        code: 'font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace; background-color: #f7fafc; padding: 0.2rem 0.4rem; border-radius: 0.25rem; font-size: 14px;',
        pre: 'font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace; background-color: #f7fafc; padding: 1rem; border-radius: 0.5rem; margin: 0.5rem 0; overflow-x: auto;',
        table: 'border-collapse: collapse; margin: 0.75rem 0; font-size: 15px; width: 100%;',
        th: 'border: 1px solid #E2E8F0; padding: 0.75rem 0.75rem; font-weight: bold; background-color: #f7fafc; font-size: 15px;',
        td: 'border: 1px solid #E2E8F0; padding: 0.75rem 0.75rem; font-size: 15px;',
        a: 'color: #3182CE; text-decoration: underline; font-size: 15px;'
    };
    
    // Process the markdown with proper styling
    let html = markdownText;
    
    // Handle code blocks first (to avoid interference with other replacements)
    html = html.replace(/```[\s\S]*?```/gim, (match) => {
        const content = match.replace(/```/g, '').trim();
        return `<pre style="${elementStyles.pre}"><code>${content}</code></pre>`;
    });
    
    // Handle inline code
    html = html.replace(/`([^`]+)`/gim, `<code style="${elementStyles.code}">$1</code>`);
    
    // Handle headers (order matters - h3 before h2 before h1)
    html = html.replace(/^### (.*$)/gim, `<h3 style="${elementStyles.h3}">$1</h3>`);
    html = html.replace(/^## (.*$)/gim, `<h2 style="${elementStyles.h2}">$1</h2>`);
    html = html.replace(/^# (.*$)/gim, `<h1 style="${elementStyles.h1}">$1</h1>`);
    
    // Handle bold and italic (order matters)
    html = html.replace(/\*\*\*(.*?)\*\*\*/gim, `<strong style="${elementStyles.strong}"><em style="${elementStyles.em}">$1</em></strong>`);
    html = html.replace(/\*\*(.*?)\*\*/gim, `<strong style="${elementStyles.strong}">$1</strong>`);
    html = html.replace(/\*(.*?)\*/gim, `<em style="${elementStyles.em}">$1</em>`);
    
    // Handle links
    html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/gim, `<a href="$2" style="${elementStyles.a}">$1</a>`);
    
         // Handle blockquotes
     html = html.replace(/^> (.+$)/gim, `<blockquote style="${elementStyles.blockquote}">$1</blockquote>`);
     
     // Handle tables - convert markdown tables to HTML
     html = convertMarkdownTablesToHtml(html, elementStyles);
     
     // Handle lists - more sophisticated approach
    const lines = html.split('\n');
    const processedLines = [];
    let inUL = false;
    let inOL = false;
    
    for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        const trimmedLine = line.trim();
        
        // Check for unordered list items
        if (/^\s*[\*\-\+]\s+/.test(line)) {
            if (!inUL) {
                if (inOL) {
                    processedLines.push('</ol>');
                    inOL = false;
                }
                processedLines.push(`<ul style="${elementStyles.ul}">`);
                inUL = true;
            }
            const content = line.replace(/^\s*[\*\-\+]\s+/, '');
            processedLines.push(`<li style="${elementStyles.li}">${content}</li>`);
        }
        // Check for ordered list items
        else if (/^\s*\d+\.\s+/.test(line)) {
            if (!inOL) {
                if (inUL) {
                    processedLines.push('</ul>');
                    inUL = false;
                }
                processedLines.push(`<ol style="${elementStyles.ol}">`);
                inOL = true;
            }
            const content = line.replace(/^\s*\d+\.\s+/, '');
            processedLines.push(`<li style="${elementStyles.li}">${content}</li>`);
        }
        // Not a list item
        else {
            if (inUL) {
                processedLines.push('</ul>');
                inUL = false;
            }
            if (inOL) {
                processedLines.push('</ol>');
                inOL = false;
            }
            
            // Handle regular paragraphs
            if (trimmedLine && !trimmedLine.match(/^<[h123456]|^<blockquote|^<pre/)) {
                processedLines.push(`<p style="${elementStyles.p}">${line}</p>`);
            } else if (trimmedLine) {
                processedLines.push(line);
            } else {
                processedLines.push('');
            }
        }
    }
    
    // Close any remaining lists
    if (inUL) processedLines.push('</ul>');
    if (inOL) processedLines.push('</ol>');
    
    html = processedLines.join('\n');
    
    // Clean up empty paragraphs and extra whitespace
    html = html.replace(/<p[^>]*>\s*<\/p>/g, '');
    html = html.replace(/\n\s*\n/g, '\n');
    
    // Wrap everything in a div with base styles
    return `<div style="${baseStyles}">${html}</div>`;
};

// Enhanced clipboard copy function that supports both formatted and plain text
export const copyFormattedToClipboard = async (markdownText) => {
    if (!markdownText) return false;
    
    try {
        // Check if the modern Clipboard API is available
        if (navigator.clipboard && navigator.clipboard.write) {
            const htmlContent = markdownToHtml(markdownText);
            const plainText = markdownText;
            
            // Create clipboard item with both HTML and plain text
            const clipboardItem = new ClipboardItem({
                'text/html': new Blob([htmlContent], { type: 'text/html' }),
                'text/plain': new Blob([plainText], { type: 'text/plain' })
            });
            
            await navigator.clipboard.write([clipboardItem]);
            return true;
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
            // Fallback to plain text only
            await navigator.clipboard.writeText(markdownText);
            return true;
        } else {
            // Legacy fallback using execCommand
            const textArea = document.createElement('textarea');
            textArea.value = markdownText;
            textArea.style.position = 'fixed';
            textArea.style.left = '-9999px';
            textArea.style.top = '-9999px';
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            return true;
        }
    } catch (error) {
        console.error('Failed to copy to clipboard:', error);
        return false;
    }
};

//<Heading as="h2" fontSize={["16px", "18px", "20px"]} my="0.4rem" {...props} />

// fontSize "xs" = 12px
// fontSize "sm" = 14px
// fontSize "md" = 16px
// fontSize "lg" = 18px


//borderRadius={'15px'} spacing={6} borderColor={'lightgray'} borderWidth={0.25}
//                                         shadow={`1.5px 1.8px 0px lightgray`}

export const sampleTranscript = "";
